import $ from 'jquery'
import {resetSelector, selectorClasses} from './selector'
import {Core} from "./core.js";

export class Search {

  constructor() {
    this.$container = $('.archive-search')

    if (this.$container.length === 0) return

    this.postType = this.$container.data('type')

    this.init()
  }

  init() {
    this.$window = $(window)
    this.$body = $('body')

    this.classInputTextSearch = '#filter-search'

    this.$filterSearch = this.$container.find(this.classInputTextSearch)
    this.$resultsGrid = $('.archive-search-results')
    this.$formSearch = this.$container.find('.archive-search-filter-form')
    this.$inputPaged = this.$formSearch.find('input[name="spaged"]')
    this.$filterTags = this.$container.find('.archive-search-filter-tags')
    this.$resetButton = this.$container.find('#reset-search-filters')
    this.$countFilters = this.$formSearch.find('#counter-filters')

    // Only for page Insights
    this.countActiveFilter = 0
    this.$insightsFlexible = this.$body.find('.insights-flexibles')

    // Only for flexible filters
    this.$flexible = this.$body.find('.advanced-search-filters')

    this.isPreviousBrowser = false
    this.formSearchSubmitTime = 0
    this.urlClean = document.location.protocol + '//' + document.location.hostname + document.location.pathname

    this.$formSearch.on('change', 'select', this.handleChangeSelect.bind(this))
    this.$formSearch.on('change submit', this.handleSubmitForm.bind(this))
    this.$container.on('click', '.archive-search-filter-tags .search-tag', this.handleClickTag.bind(this))
    this.$resetButton.on('click', this.handleResetForm.bind(this))
    this.$container.on('click', '.archive-search-pagination a', this.handleClickPagination.bind(this))
    this.$window.on('popstate', this.handlePopstate.bind(this))

    if (this.$flexible.length) {
      this.$loader = this.$flexible.find('.spinner')
    } else {
      this.$loader = $('.spinner')
    }

    // ALgo tutorial
    if (this.$formSearch.data('tutorial')) {
      this.algo = true

      this.$filterTheme = $('#filter-theme-tutorial')
      this.$filterSubTheme = $('#filter-sub-theme-tutorial')

      setTimeout(this.updateThemeAlgo.bind(this), 150)
    } else {
      this.updateTags()
    }
  }

  handlePopstate(e) {
    this.isPreviousBrowser = true
    this.resetFormByParamsUrl()
  }

  handleClickTag(e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let $select = this.$formSearch.find(`select[name="${$item.data('category')}"]`)

    $select.parent().find(`.selector-option-selected[data-value="${$item.data('value')}"]`).click()

    $item.remove()
  }

  handleChangeSelect(e) {
    if (this.algo) {
      this.updateThemeAlgo()
    } else {
      this.updateTags()
    }

    this.updateInputPaged(1)
  }

  handleResetForm(e) {
    e.preventDefault()

    this.$filterSearch.val('')

    this.$formSearch.find('select').each((index, select) => {
      resetSelector($(select).parent())
    })

    this.updateInputPaged(1)
    this.updateTags()
    this.ajaxSubmitForm()
  }

  handleClickPagination(e) {
    e.preventDefault()
    this.updateInputPaged($(e.currentTarget).data('paged'))
    this.ajaxSubmitForm()
    Core.scrollTo(this.$container)
  }

  handleSubmitForm(e) {
    e.preventDefault()

    if ($(e.target).prop('tagName') !== 'INPUT') {
      this.ajaxSubmitForm()
    }
  }

  ajaxSubmitForm() {
    let self = this
    let time = new Date().getTime()

    self.formSearchSubmitTime = time
    self.$resultsGrid.find('.alert').remove()
    self.$resultsGrid.find('.has-error').removeClass('has-error')
    self.$resultsGrid.find('.error').remove()
    self.$loader.show()

    if (self.isPreviousBrowser) {
      this.isPreviousBrowser = false
    } else {
      self.refreshUrl()
    }

    $.ajax({
      url: ajax_url.ajax_url,
      data: self.$formSearch.serialize(),
      type: 'POST',
      dataType: 'json',
      success: function (data) {
        if (time === self.formSearchSubmitTime) {
          if (data.success) {
            if (typeof data.data.header !== 'undefined') {
              $('.header-search').replaceWith(data.data.header)
            }
            if ((self.$flexible.length || self.$insightsFlexible.length) && self.countActiveFilter === 0) {
              self.$resultsGrid.html('')
            } else {
              self.$resultsGrid.html(data.data.view)
            }
          } else {
            if (data.data) {
              if ((typeof data.data) === 'string') {
                self.$resultsGrid.prepend('<div class="alert alert-warning" style="margin: 20px 0;">' + data.data + '</div>')
              }
            }
          }
          self.$loader.hide()
        }
      },
      complete: function () {
        if (time === self.formSearchSubmitTime) {
          self.$loader.hide()
        }
      }
    })
  }

  refreshUrl() {
    let urlClean = this.urlClean
    let urlParams = this.createParamsUrlWithFilters()

    if (urlParams !== '') {
      urlClean += '?' + urlParams
    }
    this.replaceUrl(urlClean)
  }

  createParamsUrlWithFilters() {
    let tabParamsUrl = this.$formSearch.serializeArray()
    let tabParams = {}

    $.each(tabParamsUrl, (index, val) => {
      let category = val.name.replace('[]', '')
      let value = val.value

      if (category === 'action'
        || category === 'page_id'
        || category === 'author_page'
        || value === 'false'
        || value === '-1'
        || (category === 'txt' && value === '')
        || (category === 'spaged' && value === '1')
      ) {
        return ''
      } else {
        if (tabParams[category] === undefined) {
          tabParams[category] = value
        } else {
          tabParams[category] += `-${value}`
        }
      }
    })
    return this.paramsTabToParamsUrl(tabParams)
  }

  getUrlParams() {
    return window.location.search.substr(1)
  }

  replaceUrl(new_url) {
    window.history.pushState({}, document.title, new_url)
  }

  paramsTabToParamsUrl(paramTab) {
    let urlParams = ''

    $.each(paramTab, function (category, data) {
      if (category !== 'action' && data !== '-1') {
        urlParams += category + '=' + data + '&'
      }
    })
    if (urlParams.length > 2) urlParams = urlParams.substring(0, urlParams.length - 1)
    return urlParams
  }

  updateInputPaged(number) {
    this.$inputPaged.val(number)
  }

  updateTags() {
    this.$filterTags.html('')
    let selectArray = this.$formSearch.find('select')

    selectArray.each((index, select) => {
      let $select = $(select)

      $select.find(':selected').each((index, option) => {
        let $option = $(option)

        if ($option.attr('value') !== '-1') {
          this.$filterTags.append(`<div class="search-tag" data-category="${$select.attr('name')}" data-value="${$option.attr('value')}"><i class="icon icon-close_1"></i>${$option.text()}</div>`)
        }
      })
    })

    this.updateFiltersCounter()
  }

  updateFiltersCounter() {
    if (this.$countFilters.length === 0 && this.$resetButton.length === 0) {
      return
    }

    this.countActiveFilter = 0

    this.$formSearch.find('select').each((index, select) => {
      const value = $(select).val()

      if (value && value !== '-1') {
        this.countActiveFilter += Array.isArray(value) ? value.length : 1
      }
    })

    if (this.$filterSearch.length && this.$filterSearch.val() && this.$filterSearch.val() !== '-1') {
      this.countActiveFilter++
    }

    if (this.countActiveFilter === 0) {
      this.$resetButton.removeClass('active')
      this.$countFilters.text(this.$countFilters.data('none'))
    } else if (this.countActiveFilter === 1) {
      this.$resetButton.addClass('active')
      this.$countFilters.text(this.$countFilters.data('single'))
    } else {
      this.$resetButton.addClass('active')
      this.$countFilters.text(String(this.$countFilters.data('multiple')).replace('%s%', this.countActiveFilter))
    }
  }

  resetFormByParamsUrl() {
    let self = this
    let params_url = this.getUrlParams().split('&')

    if (this.algo) {
      this.$filterTheme.val('-1')
      this.$filterSubTheme.val('-1')
    }

    this.$filterSearch.val('')
    this.$inputPaged.val('1')

    params_url.map(function (param_string) {
      let paramTab = param_string.split('=', 2)
      let $filter = self.$formSearch.find('[name="' + paramTab[0] + '"]')

      if ($filter.length) {
        $filter.val(paramTab[1])

        if ($filter.prop('tagName') === 'SELECT') {
          let $parent = $filter.parent()
          let $option_selected = $filter.find('option:selected')

          $parent.find('.select-selected').text($option_selected.text())
          $parent.find('.same-as-selected').removeClass('same-as-selected')
          $parent.find('.select-items').find(`div:nth-child(${$option_selected.index()})`).addClass('same-as-selected')
        }
      }
    })

    if (this.algo) {
      this.updateThemeAlgo()
    }

    this.ajaxSubmitForm()
  }

  updateThemeAlgo() {
    let self = this
    let themeValue = this.$filterTheme.val()
    let optionsVisible = []

    if (themeValue.length > 0) {
      this.$filterSubTheme.parent().find(`[data-value]`).addClass('hide')

      this.$filterSubTheme.find('option').each((i, option) => {
        let $option = $(option)
        let optionValue = Number($option.attr('value'))

        if (optionValue === -1) {
          return
        }

        let $optionFakeSelect = self.$filterSubTheme.parent().find(`[data-value="${optionValue}"]`)
        let parentId = Number($option.data('parent'))

        for (const parentIdSelected of themeValue) {
          if (parentId && parentId === Number(parentIdSelected)) {
            optionsVisible.push(Number(optionValue))
            $optionFakeSelect.removeClass('hide')
          } else if (! optionsVisible.includes(optionValue)) {
            $option.prop('selected', false)
            $optionFakeSelect.removeClass(selectorClasses.optionSelected)
          }
        }
      })

      if (optionsVisible.length !== 0) {
        this.$filterSubTheme.prop('disabled', false)
        this.updateTags()

        return
      }
    }

    this.$filterSubTheme.prop('disabled', true)
    resetSelector(this.$filterSubTheme.parent())
    this.updateTags()
  }
}
